<template>
    <div class="overview-tab p-xl bg-stone-300 w-100">
        <InnovationFocusCard
            v-if="
                props.type === 'pa' ||
                (arenaOutputStore.targetCompany.length > 0 && props.type !== 'pa')
            "
            :nodeData="props.nodeData"
            :type="props.type"
        />
        <CompetitorInnovationFocusCard :nodeData="props.nodeData" :type="props.type" />
    </div>
</template>

<script setup>
import InnovationFocusCard from './InnovationFocusCard.vue'
import CompetitorInnovationFocusCard from './CompetitorInnovationFocusCard.vue'
import { useArenaOutputStore } from '@/stores'
import { type } from '@amcharts/amcharts5'

const arenaOutputStore = useArenaOutputStore()

const props = defineProps({
    nodeData: {
        type: Object,
        default: () => {},
    },
    type: {
        type: String,
        default: 'pa',
    },
})
</script>
